/* eslint-disable react/prop-types */
import {
  AccountCircle,
  AddRoad,
  CalendarToday,
  EmailOutlined,
  Money,
  PhoneAndroidOutlined
} from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  styled,
  Switch,
  TextField
} from "@mui/material";
import React, { useState } from "react";

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    height: "80%",
    alignItems: "center",
    marginBottom: "50px"
  },
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
  height: "90vh",
  marginBottom: "50px",
  backgroundColor: "white"
}));

const RowStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "100%",
    alignItems: "center",
    marginBottom: "10px"
  },
  display: "flex",
  width: "100%",
  flexDirection: "row",
  justifyContent: "space-around",
  alignItems: "center",
  marginBottom: "10px",
  color: "#45A69F"
}));

const SwitchStyle = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "10px"
}));

const CheckBoxStyle = styled("div")(() => ({
  display: "flex",
  width: "80%",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "10px",
  marginLeft: "20px"
}));

function LifeStepOne({
  open,
  handleClose,
  handleNext,
  name,
  email,
  phone,
  add,
  dob,
  amt,
  handleName,
  handleEmail,
  handlePhone,
  handleAmt,
  handleDOB,
  handleAdd
}) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <RootStyle>
        <div style={{ flex: "0.1", marginTop: '20px' }}>
          <h1 style={{ color: "#45A69F" }}>LIFE INSURANCE</h1>
        </div>
        <RowStyle>
          <TextField
            id="outlined-name"
            label="Name"
            InputLabelProps={{
              style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", position: 'absolute', left: '2px' }
            }}
            value={name}
            onChange={handleName}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <AccountCircle /> */}
                </InputAdornment>
              )
            }}
            variant="standard"
            style={{ margin: "15px" }}
          />
          <TextField
            id="input-with-icon-textfield"
            value={email}
            label="Email"
            onChange={handleEmail}
            InputLabelProps={{
              style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", marginLeft: '2px' }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <EmailOutlined /> */}
                </InputAdornment>
              )
            }}
            variant="standard"
            sx={{ margin: "15px" }}
          />
        </RowStyle>
        <RowStyle>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="DOB"
              value={dob}
              style={{ border: "none" }}
              onChange={handleDOB}
              renderInput={(params) => (
                <TextField
                  id="icon-textfield"
                  variant="standard"
                  {...params}
                  InputLabelProps={{
                    style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", marginLeft: '2px' }
                  }}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            id="input-with-icon-textfield"
            label="City"
            value={add}
            onChange={handleAdd}
            InputLabelProps={{
              style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", marginLeft: '2px' }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <AddRoad /> */}
                </InputAdornment>
              )
            }}
            variant="standard"
            sx={{ margin: "15px" }}
          />
        </RowStyle>
        <RowStyle>
          <TextField
            value={phone}
            onChange={handlePhone}
            id="input-with-icon-textfield"
            label="Phone"
            InputLabelProps={{
              style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", marginLeft: '2px' }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <PhoneAndroidOutlined /> */}
                </InputAdornment>
              )
            }}
            variant="standard"
            sx={{ margin: "15px" }}
          />
          <TextField
            id="input-with-icon-textfield"
            value={amt}
            onChange={handleAmt}
            label="Life Cover Amount"
            InputLabelProps={{
              style: { color: "#45A69F", fontSize: "20px", fontWeight: "600", marginLeft: '2px' }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <Money /> */}
                </InputAdornment>
              )
            }}
            variant="standard"
            sx={{ margin: "15px" }}
          />
        </RowStyle>
        <CheckBoxStyle>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox defaultChecked />}
              label="I accept to the terms and conditions. I autorise company to call me."
            />
          </FormGroup>
          <Button
            sx={{ background: "#45A69F", color: "white", width: "200px", "&:hover": { backgroundColor: "#45A69F", } }}
            onClick={handleNext}>
            Next <img src="/images/icons/login.png" />{" "}
          </Button>
        </CheckBoxStyle>
      </RootStyle>
    </Dialog>
  );
}

export default LifeStepOne;
